import SvgIcon, { SvgIconProps } from 'LuxKit/SvgIcon'

function LineBookmarkFullIcon(props: SvgIconProps) {
  return <SvgIcon {...props} fill="none" viewBox="0 0 24 24">
    <path fill="currentColor" d="M18 2H6a1 1 0 0 0-1 1v18a1 1 0 0 0 1.65.76L12 17.27l5.29 4.44A1.0003 1.0003 0 0 0 18 22a.8395.8395 0 0 0 .38-.08A1.0004 1.0004 0 0 0 19 21V3a1.0002 1.0002 0 0 0-1-1Zm-1 16.86-4.36-3.66a.9997.9997 0 0 0-1.28 0L7 18.86V4h10v14.86Z"/>
  </SvgIcon>
}

export default LineBookmarkFullIcon
